import { render, staticRenderFns } from "./level_label.vue?vue&type=template&id=46d757b9&scoped=true&"
import script from "./level_label.vue?vue&type=script&lang=js&"
export * from "./level_label.vue?vue&type=script&lang=js&"
import style0 from "./level_label.vue?vue&type=style&index=0&id=46d757b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d757b9",
  null
  
)

export default component.exports